
import { Lottery, LotteryInfos } from "@/StaticName";
import * as imageConversion from 'image-conversion'

// 判断是否为空
export function validatenull(val) {
  if (val === 'null' || val === null || val === 'undefined' || val === undefined || val === '') return true;
  if (val instanceof Boolean) { return false; }
  if (val instanceof Number) { return false; }
  if (val instanceof Array) { if (val.length == 0) return true; }
  else if (val instanceof Object) { if (JSON.stringify(val) === '{}') return true; }
  else { return false; }
}

export const getAwardNums = (lotId, awardNum, def = '') => {
  if (validatenull(awardNum)) {
    if (def.length <= 0) { throw '开奖号有误' } else {
      const curLotInfo = LotteryInfos.find((o) => o.id === lotId)
      return curLotInfo.ball.map(o => { let nums = []; for (let i = 0; i < o.n; i++) { nums.push(def) } return nums })
    }
  } else {
    const curLotInfo = LotteryInfos.find((o) => o.id === lotId)
    let s = 0; let awardNums = awardNum.split(",");
    return curLotInfo.ball.map(o => { let nums = awardNums.slice(s, s + o.n); s += o.n; return nums; })
  };
}

/**
 * 复杂类型深拷贝
 * @param {*} obj 数据
 */
export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj
  const cpObj = obj instanceof Array ? [] : {}
  for (let key in obj) cpObj[key] = deepClone(obj[key])
  return cpObj
}

export const updPtCls = (v, item, str, index) => {

  if (item.lottery_num) {
    let r = getAwardNums(item.lotteryId, item.lottery_num)[0]
    let b = getAwardNums(item.lotteryId, item.lottery_num)[1]

    if (
      item.lotteryId == Lottery.fc3d.id ||
      item.lotteryId == Lottery.pl3.id ||
      item.lotteryId == Lottery.pl5.id
    ) {
      if (str == 'r' && r[index].includes(v)) {
        return 'btnrndred'
      } else if (str == 'b' && b && b.includes(v)) {
        return 'btnrndblue'
      } else {
        return ''
      }
    } else {

      if (str == 'r' && r.includes(v)) {
        return 'btnrndred'
      } else if (str == 'b' && b && b.includes(v)) {
        return 'btnrndblue'
      } else {
        return ''
      }
    }
  } else {
    return ''
  }
}

export function getImgArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let fileResult = "";
    reader.readAsArrayBuffer(file);
    reader.onload = function () {
      fileResult = reader.result;
      resolve(fileResult);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}

export const beforeRead = (file) => {

  return new Promise((resolve, reject) => {
    if (file.type.includes("image") && file.size > 100 * 1000) {
      imageConversion.compressAccurately(file, 100).then(res => {
        let f = new File([res], file.name, {
          type: file.type
        })
        resolve(f)
      })

    } else {
      resolve(file)
    }
  })

}

export const dataURLtoFile = (dataUrl, fileName) => {
  var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}